import type { DeepPartial } from '@luna/utils-ts';

import { dashboardHUFeatureConfig } from './dashboard/HU';
import type { InvestmentsFeatureConfig } from '../types/InvestmentsFeatureConfig';
import { documentsHUFeatureConfig } from './documents/HU';
import { miscHUFeatureConfig } from './misc/HU';
import { ordersHUFeatureConfig } from './orders/HU';
import { overviewHUFeatureConfig } from './overview/HU';
import { pipHUFeatureConfig } from './pip/HU';
import { printHUFeatureConfig } from './print/HU';
import { productSettingsHUFeatureConfig } from './productSettings/HU';
import { searchHUFeatureConfig } from './search/HU';
import { statementsHUFeatureConfig } from './statements/HU';
import { tradingConfigHU } from './trading/HU';

export const investments: DeepPartial<InvestmentsFeatureConfig> = {
    dashboard: dashboardHUFeatureConfig,
    documents: documentsHUFeatureConfig,
    misc: miscHUFeatureConfig,
    orders: ordersHUFeatureConfig,
    overview: overviewHUFeatureConfig,
    pip: pipHUFeatureConfig,
    print: printHUFeatureConfig,
    productSettings: productSettingsHUFeatureConfig,
    search: searchHUFeatureConfig,
    statements: statementsHUFeatureConfig,
    trading: tradingConfigHU,
};
